<template>
  <div style="padding-top: 2rem">
    <b-row class="mb-2">
      <b-col lg="4">
        <b-input-group>
          <b-form-input v-model="filter" :placeholder="$t('type_to_search')" />
          <b-input-group-append>
            <b-button variant="danger" :disabled="!filter" @click="filter = ''">{{ $t('clear') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="9">
        <EasyDataTable
          :headers="fields"
          :items="normScales"
          :search-value="filter"
          :alternating="true"
          :rows-per-page="10000"
          :hide-rows-per-page="true"
        >
          <template #item-languages="item">
            <span v-for="translation in item.translations" :key="translation.countryCode">
              <span :class="'flagItem flag-icon flag-icon-' + translation.countryCode"></span>
            </span>
          </template>
          <template #item-selected="item">
            <b-form-checkbox v-model="item.selected" @click="onChangeSelected(item)" />
          </template>
        </EasyDataTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'norm-scale-table',
  props: ['normScales', 'onChangeSelected'],
  data() {
    return {
      filter: ''
    }
  },
  computed: {
    fields() {
      return [
        {
          value: 'scaleName',
          text: this.$t('privatePage.scale'),
          sortable: true
        },
        {
          value: 'normGroupName',
          text: this.$t('privatePage.normgroup'),
          sortable: true
        },
        { value: 'languages', text: this.$t('lang') },
        {
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true,
          tdClass: 'rightAlignedField',
          thClass: 'rightAlignedField'
        }
      ]
    }
  }
}
</script>

<style scoped>
.flagItem {
  margin-right: 2px;
}
</style>
